module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "listRoot",
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("自动排课配置管理")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminConfig/getTConfigList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "学导id",
      "width": _vm.modalWidth
    },
    model: {
      value: (_vm.showValueModal),
      callback: function($$v) {
        _vm.showValueModal = $$v
      },
      expression: "showValueModal"
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-all",
      "white-space": "pre-wrap",
      "max-height": "360px",
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.fullValue))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showValueModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    staticClass: "modal",
    attrs: {
      "title": "编辑配置信息",
      "width": _vm.modalWidth
    },
    model: {
      value: (_vm.showEditTconfig),
      callback: function($$v) {
        _vm.showEditTconfig = $$v
      },
      expression: "showEditTconfig"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ids：",
      "prop": "configValue"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.configValue),
      callback: function($$v) {
        _vm.$set(_vm.formData, "configValue", $$v)
      },
      expression: "formData.configValue"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.enabledStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-909f3670","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminTConfigList.vue
// module id = 1918
// module chunks = 8